import { FetchError } from '../errors/FetchError'
import { fetchApiImageAuth2, fetchWithAuthorization } from './fetch'

export const createPost = async (obj) => {
  try {
    const data = await fetchApiImageAuth2('/post', obj, 'POST')
    return data
  } catch (error) {
    throw new FetchError(error, 'Ha ocurrido un error al intentar realizar una publicación.')
  }
}

export const createRelease = async (obj) => {
  try {
    const data = await fetchApiImageAuth2('/release', obj, 'POST')
    return data
  } catch (error) {
    throw new FetchError(error, 'Ha ocurrido un error al intentar realizar una publicación.')
  }
}

export const createComment = async (post, obj) => {
  try {
    const data = await fetchWithAuthorization(`/post/comment/${post}`, obj, 'POST')
    return data
  } catch (error) {
    throw new FetchError(error, 'Ha ocurrido un error al intentar realizar una publicación.')
  }
}

export const deleteComment = async (post) => {
  try {
    const data = await fetchWithAuthorization(`/post/comment/${post}`, null, 'DELETE')
    return data
  } catch (error) {
    throw new FetchError(error, 'Ha ocurrido un error al intentar realizar una publicación.')
  }
}

export const deletePost = async (post) => {
  try {
    const data = await fetchApiImageAuth2(`/post/${post}`, null, 'DELETE')
    return data
  } catch (error) {
    throw new FetchError(error, 'Ha ocurrido un error al intentar eliminar una publicación.')
  }
}

export const deleteRelease = async (post) => {
  try {
    const data = await fetchApiImageAuth2(`/release/${post}`, null, 'DELETE')
    return data
  } catch (error) {
    throw new FetchError(error, 'Ha ocurrido un error al intentar eliminar una publicación.')
  }
}
